import React from "react";

function Photos() {
    return (
        <div className="photos">
                <div className="row photos-row g-3 m-0">
                    <div className="col-xl-6 col-md-12">
                        <img src="/s3/complex-1.png" alt="" className="responsive-image"/>
                    </div>
                    <div className="col-xl-6 col-md-12">
                        <img src="/s3/complex-2.png" alt="" className="responsive-image"/>
                    </div>
                    <div className="col-12">
                        <img src="/s3/complex-3.png" alt="" className="responsive-image"/>
                    </div>
                    <div className="col-xl-6 col-lg-12">
                        <img src="/s3/complex-4.png" alt="" className="responsive-image"/>
                    </div>
                    <div className="col-xl-6 col-lg-12">
                        <img src="/s3/complex-5-14.png" alt="" className="responsive-image"/>
                    </div>
                    <div className="col-12">
                        <img src="/s3/complex-6.png" alt="" className="responsive-image"/>
                    </div>
                    <div className="col-xl-6 col-lg-12">
                        <img src="/s3/complex-7.png" alt="" className="responsive-image"/>
                    </div>
                    <div className="col-xl-6 col-lg-12">
                        <img src="/s3/complex-8.png" alt="" className="responsive-image"/>
                    </div>
                    <div className="col-12">
                        <img src="/s3/complex-9.png" alt="" className="responsive-image"/>
                    </div>
                    <div className="col-xl-6 col-lg-12">
                        <img src="/s3/complex-10.png" alt="" className="responsive-image"/>
                    </div>
                    <div className="col-xl-6 col-lg-12">
                        <img src="/s3/complex-11.png" alt="" className="responsive-image"/>
                    </div>
                    <div className="col-xl-6 col-lg-12">
                        <img src="/s3/complex-12.png" alt="" className="responsive-image"/>
                    </div>
                    <div className="col-xl-6 col-lg-12">
                        <img src="/s3/complex-13.png" alt="" className="responsive-image"/>
                    </div>
                    <div className="col-xl-6 col-lg-12">
                        <img src="/s3/complex-5-14.png" alt="" className="responsive-image"/>
                    </div>
                    <div className="col-xl-6 col-lg-12">
                        <img src="/s3/complex-15.png" alt="" className="responsive-image"/>
                    </div>
                </div>
            </div>
    );
}

export default Photos;